import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Box, Button, DialogActions, DialogContent, DialogContentText, Grid, Typography } from '@mui/material';
import SingleDateClearable from 'components/common/DateRangePickerCC/SingleDateClearable';
import useHandleDateRangePicker from 'components/common/DateRangePickerCC/useHandleDateRangePicker';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import { isNumber } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { setCloseDialogCC } from 'utils/helpers';
import { DIALOG_ID } from './constant';
import { DEFAULT_TIMESEARCH } from 'constants/search';
import { convertHourAndMinToSecond, roundTimeStartDay } from 'pages/manager-meeting/functions';
import { TimePickerCC } from 'pages/manager-meeting/components/TimePickerCC';

const DialogAddAccountRole = () => {
    const open = useSelector((state) => state.dialog.open);
    const propsDialog = useLegacyDialogProps();
    const { item, onClick } = propsDialog;
    const [expireDate, setExpireDate] = useState(null);
    const [expireTime, setExpireTime] = useState(null);
    const { t } = useTranslation('pgRole')
    const { timePicker: startTimePicker } = useHandleDateRangePicker({
        startDate: roundTimeStartDay(),
        endDate: DEFAULT_TIMESEARCH.endDate,
    });

    useEffect(() => {
        setExpireDate(null);
        setExpireTime(null);
    }, [open])

    return (
        <DialogBaseCC id={DIALOG_ID.ADD_ACCOUNT_ROLE} title={t('dialog.expire-title')}>
            <DialogContent sx={{ maxWidth: '100% !important' }}>
                <DialogContentText sx={{ maxWidth: '100% !important' }}>
                    <Box>
                        <Box>{`${t('dialog.role-name')} `} <b>{item?.name}</b></Box>
                        <Box>{t('dialog.expire-undefine')}<b>{` ${t('dialog.expire-time')}`}</b></Box>
                        <Box mt={1}>
                            <Typography sx={{ marginBottom: '5px' }}>{t('dialog.expire-time')}</Typography>
                            <Grid container>
                                <Grid item xs={8}>
                                    <SingleDateClearable
                                        inputId="input-date-role-expire"
                                        timePicker={startTimePicker}
                                        setTimePicker={({ date, _ }) => {
                                            setExpireDate(date?.unix() || null)
                                        }}
                                        initialSettingsProps={{
                                            singleDatePicker: true,
                                            showDropdowns: true,
                                            maxDate: moment('2038-01-18', 'YYYY-MM-DD').toDate(),
                                            minDate: moment().toDate()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={4} pl={2}>
                                    <TimePickerCC
                                        id={'timepicker-role-expire'}
                                        // value={convertSecondToHourAndMinute(dataPeriod.startSecond)}
                                        disabled={!expireDate}
                                        setValue={(_time) => {
                                            let time = convertHourAndMinToSecond(_time);
                                            setExpireTime(time)
                                        }}
                                        minTime={expireDate === moment().startOf('day').unix() ? moment().add(1, 'minutes').format('HH:mm') : null}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={setCloseDialogCC}>{t('button.cancel')}</Button>
                <Button disabled={expireDate && !expireTime} onClick={() => { if (expireDate) { onClick({ ...item, expire_time: (expireDate + (isNumber(expireTime) ? expireTime : 86399)) }) } else { onClick(item) } }}>{t('button.save-expire')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogAddAccountRole
